/* global axios */

import Cookies from 'js-cookie';
import endPoints from './endPoints';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';

// [SUDONUM HACK] Redirect to Sudonum frontend on logout
const SUDONUM_FRONTEND_APP_URL = 'https://app.sudonum.com';

export default {
  validityCheck() {
    const urlData = endPoints('validityCheck');
    return axios.get(urlData.url);
  },
  logout() {
    const urlData = endPoints('logout');
    const fetchPromise = new Promise((resolve, reject) => {
      axios
        .delete(urlData.url)
        .then(response => {
          deleteIndexedDBOnLogout();
          clearCookiesOnLogout();
          resolve(response);
          // [SUDONUM HACK] Redirect to Sudonum frontend
          window.location.replace(SUDONUM_FRONTEND_APP_URL);
        })
        .catch(error => {
          reject(error);
        });
    });
    return fetchPromise;
  },
  hasAuthCookie() {
    return !!Cookies.get('cw_d_session_info');
  },
  getAuthData() {
    if (this.hasAuthCookie()) {
      const savedAuthInfo = Cookies.get('cw_d_session_info');
      return JSON.parse(savedAuthInfo || '{}');
    }
    return false;
  },
  profileUpdate({ displayName, avatar, ...profileAttributes }) {
    const formData = new FormData();
    Object.keys(profileAttributes).forEach(key => {
      const hasValue = profileAttributes[key] === undefined;
      if (!hasValue) {
        formData.append(`profile[${key}]`, profileAttributes[key]);
      }
    });
    formData.append('profile[display_name]', displayName || '');
    if (avatar) {
      formData.append('profile[avatar]', avatar);
    }
    return axios.put(endPoints('profileUpdate').url, formData);
  },

  profilePasswordUpdate({ currentPassword, password, passwordConfirmation }) {
    return axios.put(endPoints('profileUpdate').url, {
      profile: {
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
      },
    });
  },

  updateUISettings({ uiSettings }) {
    return axios.put(endPoints('profileUpdate').url, {
      profile: { ui_settings: uiSettings },
    });
  },

  updateAvailability(availabilityData) {
    return axios.post(endPoints('availabilityUpdate').url, {
      profile: { ...availabilityData },
    });
  },

  updateAutoOffline(accountId, autoOffline = false) {
    return axios.post(endPoints('autoOffline').url, {
      profile: { account_id: accountId, auto_offline: autoOffline },
    });
  },

  deleteAvatar() {
    return axios.delete(endPoints('deleteAvatar').url);
  },

  resetPassword({ email }) {
    const urlData = endPoints('resetPassword');
    return axios.post(urlData.url, { email });
  },

  setActiveAccount({ accountId }) {
    const urlData = endPoints('setActiveAccount');
    return axios.put(urlData.url, {
      profile: {
        account_id: accountId,
      },
    });
  },
  resendConfirmation() {
    const urlData = endPoints('resendConfirmation');
    return axios.post(urlData.url);
  },
  resetAccessToken() {
    const urlData = endPoints('resetAccessToken');
    return axios.post(urlData.url);
  },
  // [SUDONUM HACK] Session management methods for SessionTimeoutModal
  isAuthenticated() {
    return !!Cookies.get('cw_d_session_info');
  },
  refreshToken() {
    const newExpiryTime = new Date(new Date().getTime() + (720 * 60 * 1000));
    try {
      const sessionCookie = Cookies.get('cw_d_session_info');
      if (sessionCookie) {
        const cookieData = JSON.parse(sessionCookie);
        cookieData.expiry = Math.floor(newExpiryTime.getTime() / 1000);
        Cookies.set('cw_d_session_info', JSON.stringify(cookieData));
      }
    } catch (error) {
      console.error('Error refreshing session:', error);
    }
  },
  isSessionExpired() {
    const now = new Date().getTime();
    try {
      const sessionCookie = Cookies.get('cw_d_session_info');
      if (!sessionCookie) {
        return true;
      }

      const cookieData = JSON.parse(sessionCookie);
      const expiryTime = parseInt(cookieData.expiry) * 1000;
      return now >= expiryTime;
    } catch (error) {
      console.error('Error checking session expiry:', error);
      return true;
    }
  },
  getTimeUntilExpiration() {
    try {
      const sessionCookie = Cookies.get('cw_d_session_info');
      if (!sessionCookie) {
        return 0;
      }

      const cookieData = JSON.parse(sessionCookie);
      const expiryTime = parseInt(cookieData.expiry) * 1000;
      const now = new Date().getTime();

      return Math.max(0, Math.floor((expiryTime - now) / 1000));
    } catch (error) {
      console.error('Error calculating time until expiration:', error);
      return 0;
    }
  },
  handleSessionExpiration(force_log_out = false) {
    try {
      const sessionIsExpired = this.isSessionExpired();
      if (force_log_out || sessionIsExpired) {
        deleteIndexedDBOnLogout();
        clearCookiesOnLogout();
        window.location.reload();
        window.location.replace(SUDONUM_FRONTEND_APP_URL);
      }
    } catch (error) {
      console.error('Session expiration handling failed:', error);
      window.location.reload();
      window.location.replace(SUDONUM_FRONTEND_APP_URL);
    }
  },
};
